import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'
import { compose } from 'recompose'

import { getActivityStatusesForCurrentNoteThreads } from 'data/activityRegistry/selectors'

import ThreadPanel from './ThreadPanel'
import MainPanel from './MainPanel'

import { withNoteMetaPanelControls } from 'routes/utils/withNoteMetaPanelControls'

class Panels extends Component {
  static propTypes = {
    noteId: PropTypes.string.isRequired,
    goToThreadPanel: PropTypes.func,
    showComments: PropTypes.func.isRequired,
    toggleComments: PropTypes.func.isRequired,
    activityStatuses: PropTypes.instanceOf(Map).isRequired,
    threadId: PropTypes.string,
  }

  state = {
    displayClosedThread: false,
  }

  onMainPanelNavigation = () => {
    this.props.toggleComments({ mainPanel: true })
  }

  setDisplayClosedThreadBanner = arg => {
    this.setState({ displayClosedThread: arg })
    clearTimeout(this.displayBanner)
    if (arg) {
      this.displayBanner = setTimeout(
        () => this.setState({ displayClosedThread: false }),
        4000
      )
    }
  }

  componentWillUnmount = () => {
    clearTimeout(this.displayBanner)
  }

  render() {
    const { noteId, threadId, showComments, activityStatuses } = this.props

    return (
      <div className="l-meta zindex-large overflow-hidden flexbox flexbox-column border-left-medium border-shade-50 background-shade-100">
        {threadId ? (
          <ThreadPanel
            activeThreadId={threadId}
            goToMainPanelView={this.onMainPanelNavigation}
            noteId={noteId}
            setDisplayClosedThreadBanner={this.setDisplayClosedThreadBanner}
            showBanner={this.state.displayClosedThread}
            onCloseBanner={() => this.setState({ displayClosedThread: false })}
          />
        ) : (
          <MainPanel
            noteId={noteId}
            goToThreadPanel={threadId => {
              this.setState({ displayClosedThread: false })
              showComments({ threadId })
            }}
            activityStatuses={activityStatuses}
            showBanner={this.state.displayClosedThread}
            onCloseBanner={() => this.setState({ displayClosedThread: false })}
          />
        )}
      </div>
    )
  }
}

export default compose(
  withNoteMetaPanelControls,
  connect(state => ({
    activityStatuses: getActivityStatusesForCurrentNoteThreads(state),
  }))
)(Panels)
